import React from 'react';

import { defineMessages, useIntl } from 'react-intl-next';

import { IconButton, type IconButtonProps } from '@atlaskit/button/new';
import LinkIcon from '@atlaskit/icon/core/link';
import { usePlatformInstrumentation } from '@atlassian/platform-analytics';

import { useAudioPlayerStore } from '../../hooks/useAudioPlayerStore';
import { useAudioShareLinkCopy } from '../../hooks/useAudioShareLinkCopy';

const messages = defineMessages({
	tooltip: {
		id: 'audio.audio-player.audio-share-link-button.link',
		defaultMessage: 'Link to audio',
		description: 'Tooltip for the audio share link button',
	},
	label: {
		id: 'audio.audio-player.audio-share-link-button.label',
		defaultMessage: 'Copy link to audio',
		description: 'Label for the audio share link button',
	},
});

export const AudioShareLinkButton = () => {
	const { formatMessage } = useIntl();
	const { activeContent, activeFeature } = useAudioPlayerStore();
	const { copyAudioShareLinkToClipboard } = useAudioShareLinkCopy();
	const { sendUIEvent } = usePlatformInstrumentation();

	const handleCopyLink = () => {
		copyAudioShareLinkToClipboard(
			activeContent.mainContentLink,
			activeFeature,
			activeContent.supportingContent,
		);
		sendUIEvent({
			eventType: 'ui',
			action: 'clicked',
			actionSubject: 'aiAudioCopyLink',
			attributes: {
				contentType: activeContent.contentType,
				trackType: activeFeature,
			},
		});
	};

	const tooltipOptions: IconButtonProps['tooltip'] = {
		content: formatMessage(messages.tooltip),
		position: 'bottom',
		hideTooltipOnClick: true,
	};

	return (
		<IconButton
			icon={LinkIcon}
			label={formatMessage(messages.label)}
			tooltip={tooltipOptions}
			onClick={handleCopyLink}
			isTooltipDisabled={false}
			isDisabled={activeContent.mainContentLink === ''}
			shape="circle"
		/>
	);
};
